import * as React from "react";
import Snackbar from "@mui/material/Snackbar";

import { Alert } from "@mui/material";
import {
  getErrorMessage,
  isSuccess,
  removeError,
} from "../redux/slices/errorSlice";

import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";

export default function SnackbarSuccess() {
  const dispatch = useAppDispatch();
  const showError = useAppSelector(isSuccess);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(removeError());
  };

  return (
    <Snackbar open={showError} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
        {useAppSelector(getErrorMessage)}
      </Alert>
    </Snackbar>
  );
}
